<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Select Exam to Score'"
    :submit-button-text="'SELECT'"
    :reset-modal="resetModal"
    :submit-modal="selectExam"
    :submit-disabled="!selectedExam || !selectedCourse"
  >
    <b-row>
      <b-col>
        <p class="tsny_text">
          Select the exam you wish to score. On the next page, you'll find a
          scantron where you can provide your answers.
        </p>
      </b-col>
    </b-row>
    <b-row :class="{ isStaff: 'row-cols-1' }"
      ><b-col class="col-auto mb-3" v-if="courseOptions.length > 1">
        <b-select
          v-model="selectedCourse"
          :options="courseOptions"
          class="tsny_button tsny_dropdown"
          @change="courseChanged"
        /> </b-col
      ><b-col>
        <b-select
          v-model="selectedExam"
          :options="examOptions"
          class="tsny_button tsny_dropdown"
        /> </b-col
    ></b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import { mapGetters } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";
export default {
  name: "SelectExamModal",
  components: { TsnyModal },
  computed: {
    ...mapGetters({
      courseRelationships: StoreConstants.GETTERS.COURSES,
      isStaff: StoreConstants.GETTERS.IS_STAFF
    }),
    courseOptions() {
      return this.courseRelationships.map(course => ({
        text: this.isStaff
          ? `${course.courseId} -- ${course.studentEmail}`
          : course.courseId,
        value: course
      }));
    },
    examOptions() {
      if (!this.selectedCourse) return [];

      return this.selectedCourse.course.practiceExams.map(exam => ({
        text: exam.examName,
        value: exam
      }));
    }
  },
  data: () => ({
    modalId: "selectExamModal",
    selectedCourse: null,
    selectedExam: null
  }),
  methods: {
    courseChanged() {
      this.selectedExam = null;
    },
    resetModal() {
      if (this.courseOptions.length === 1) {
        this.selectedCourse = this.courseOptions[0].value;
      } else {
        this.selectedCourse = null;
      }
      this.selectedExam = null;
    },
    selectExam() {
      this.$router.push({
        name: "SubmitScantron",
        params: {
          relationshipId: this.selectedCourse._id,
          exam: this.selectedExam
        }
      });
    }
  }
};
</script>

<style scoped></style>
